
import {createStore,applyMiddleware,compose} from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './reducers';
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const middleware = [thunk];
const emptyStore={
    scs_store:{
        services:[],
        service:{}
    }
}
 
const store = createStore(
  rootReducer,
  emptyStore,
  composeEnhancers(applyMiddleware(...middleware))
);


export default store;